import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLoanBalance,
  fetchLoanAccountsBySearch,
} from "./loanBalanceThunk";

const initialState = {
  list: [],
  loading: false,
  loanAccounts: [],
  loanAccountLoading: false,
  balanceTotal: 0,
  filters: {
    filterType: "All Loan Account", // "All Loan Account" | "Loan Account Wise" | "Date Wise"
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const loanBalanceSlice = createSlice({
  name: "loanBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoanBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoanBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.loans;
        state.balanceTotal = action.payload.total_balance;
      })
      .addCase(fetchLoanBalance.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchLoanAccountsBySearch.pending, (state) => {
        state.loanAccountLoading = true;
      })
      .addCase(fetchLoanAccountsBySearch.fulfilled, (state, action) => {
        state.loanAccountLoading = false;
        state.loanAccounts = action.payload;
      })
      .addCase(fetchLoanAccountsBySearch.rejected, (state) => {
        state.loanAccountLoading = false;
        state.loanAccounts = [];
      });
  },
});

export const { setFilters } = loanBalanceSlice.actions;
export default loanBalanceSlice.reducer;
